export default "__VITE_ASSET__838285c6__"